import { render, staticRenderFns } from "./AttanchmentPreview.vue?vue&type=template&id=92a6c410&"
import script from "./AttanchmentPreview.vue?vue&type=script&lang=js&"
export * from "./AttanchmentPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports